import Tooltip from '@/tooltip';
import { CalendarDaysIcon, ChevronDownIcon, ClipboardDocumentListIcon, ClipboardIcon, ClockIcon, UserGroupIcon } from '@heroicons/react/20/solid';
import { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { Actions as ADMINACTIONS } from '../../store/actions/adminActions';
import { Actions as PAYMENT_ACTIONS } from '../../store/actions/paymentActions';
import BillingEmails from '../billing/BillingEmails';
import CompanyCreditHistory from "../billing/CreditHistory";
import Billing from '../company-settings/billing-tab/Billing';
import { copyToClipboard } from '@/helpers/ClipboardHelpers';


const tabs = [
	{
		link: "/billing",
		name: "Effect Payment",
	},
	{
		link: "/billing/credit-history",
		name: "Credit History",
	},
	{
		link: "/billing/emails",
		name: "Billing Emails",
	},
];

const SuspendedAccount = ({
    companyName,
    advisorDetails,
    businessDetails,
    refCode,
    isAdmin,
    deferSuspendedAccount,
    getCredits,

}) => {

    useEffect(() => {
		getCredits({});
    }, []);

    const [expand, setExpand] = useState(false)
    const [currentTab, setTab] = useState(tabs[0].name)

    let innerContent = null

    switch (currentTab) {
        case "Effect Payment":
            innerContent = (<>
                <div className="content bg-white">
                    <Billing/>
                </div>

                <div className="content bg-white" style={{marginBottom: 30}}>
                    <div className='col-lg-12 col-xs-12 form-section'>
                        <div className={`col-xs-12 form-container`}>
                            <div className="col-xs-6 pl-0">
                                <h4>
                                    Pay by Bank Transfer
                                </h4>
                            </div>
                            <div className="pl-0 w-100 pull-right">
                                <button
                                    className="btn btn-default"
                                    onClick={() => {
                                        setExpand(!expand)
                                    }}
                                >
                                    <ChevronDownIcon
                                        style={{
                                            height: "1.5em",
                                            float: "left",
                                            transform: expand ? "rotate(180deg)" : "rotate(0deg)",
                                            transition: "transform 0.2s ease-in-out",
                                        }}/>
                                </button>
                            </div>
                            {expand ? <>
                                <br/><br/>
                                <p style={{color: '#4d555d'}}>You can make a payment on account using the below bank
                                    details:</p>
                                <p style={{color: '#4d555d'}}>Account Holder: Buddy Ltd<br/>IBAN: GB53MOOW00993506753612<br/>BIC:
                                    MOOWGB22XXX<br/>Bank Name: Moorwand Limited<br/>Bank Address: Irongate House, 28-30
                                    Dukes Place, London, EC3A 7LP<br/>Bank Country: United Kingdom (GB)</p>
                                <p style={{color: '#4d555d'}}>
                                    Payment on account
                                    for <strong>{advisorDetails?.name ?? businessDetails?.name}</strong><br/>
                                    Use This Reference Code: <strong>{refCode}</strong>
                                    <button className="btn btn-default" style={{marginLeft: 5}}
                                            onClick={() => copyToClipboard(refCode)}>
                                        <ClipboardIcon style={{height: "1em", float: "left"}}/>
                                    </button>
                                </p>
                                <p style={{color: '#4d555d'}}>
                                    All Payments will be automatically allocated within 24 hours of reciept
                                    <br/>
                                    Payments with incorrect reference codes will, require manual intervention, and are
                                    subject to a 10 Credit administration fee.
                                </p>
                                <div className='clearfix'></div>
                            </> : null}
                        </div>
                    </div>
                </div>
                <div className='clearfix'></div>
            </>)
            break;
        case "Credit History":
            innerContent = (<CompanyCreditHistory/>)
            break;
        case "Billing Emails":
            innerContent = (<BillingEmails/>)
    }

    return (
        <>
            <div className="block text-center bg-white" style={{ paddingTop: 120 }}>
                <div id="all-done">
                    <div className="item item-circle bg-success" style={{ position: 'relative', height: '8rem', width: '8rem', marginBottom: '2rem' }} >
                        <ClockIcon style={{ position: 'absolute', height: '6rem', color: 'white', right: '1rem', top: '1rem' }} />
                    </div>
                    <div className="item item-circle bg-primary" style={{ position: 'relative', height: '12rem', width: '12rem', marginLeft: '1rem', marginRight: '1rem' }} >
                        <UserGroupIcon style={{ position: 'absolute', height: '10rem', color: 'white', right: '1rem', top: '1rem' }} />
                    </div>
                    <div className="item item-circle bg-danger" style={{ position: 'relative', height: '8rem', width: '8rem', marginBottom: '2rem' }} >
                        <CalendarDaysIcon style={{ position: 'absolute', height: '6rem', color: 'white', right: '1rem', top: '1rem' }} />
                    </div>
                    <div className="main">
                        <h1 className="font-w700 text-center"></h1>
                        <h4 className="text-center">{companyName}'s account is currently suspended. </h4>
                        <p className="text-center">Please update your card details or make a bank payment to reactivate this account.
                            Please note, bank payments may take a few days to process, and your account will be reactivated only after the payment is confirmed by your bank.</p>
                    </div>
                    {isAdmin &&
                        <Tooltip content="Admin: Defer Account Suspension">
                            <button className='btn btn-primary' onClick={deferSuspendedAccount}>
                                <ClipboardDocumentListIcon style={{ height: "1.5em", float: "left", marginRight: 5 }} />
                                <div style={{ float: "left" }}>Defer Account Suspension</div>
                            </button>
                        </Tooltip>
                    }
                </div>
            </div>

            <ul className="nav nav-tabs nav-tabs-alt nav-justified">
				{tabs.map((tab) => {
					return (
						<li className={currentTab === tab.name ? "active" : ""}>
                            <a href="#" onClick={(e) => {e.preventDefault(); setTab(tab.name)}}>{tab.name}</a>
						</li>
					);
				})}
			</ul>

            {innerContent}


            <div className='clearfix'></div>
        </>
    )
};

const mapStateToProps = (state) => {

    const { businessDetails, advisorDetails } = (state.payment && state.payment.stats) || 0;


    return {
        orgId: state?.company?.settings?.org,
        companyName: state?.company?.settings?.name,
        advisorDetails,
        businessDetails,
        refCode: advisorDetails?.billingReference ?? businessDetails?.billingReference,
        isAdmin: state.my?.profile?.isAdmin,
    }
}

const mapDispatchToProps = dispatch => ({
    deferSuspendedAccount: () => dispatch(ADMINACTIONS.deferSuspendedAccount()),
    getCredits: ({ before, after }) => dispatch(PAYMENT_ACTIONS.getCredits({ before, after })),

});

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(SuspendedAccount)